import React from 'react';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';
import { Typeahead } from 'react-bootstrap-typeahead';
import CustomInput from '../../components/CustomInput';
import {
    Row,
    Button,
    FormGroup,
    Label,
    Col,
    Container,
    Input,
} from 'reactstrap';

import {
    showLoading,
    sendBulkPaymentReminder,
    fetchOptions
} from '../../redux/actions';
import { check_empty_field } from './validationChecks';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import _ from 'lodash';
import { IonButton, IonPage } from '@ionic/react';

const mapDispatchToProps = {
    showLoading,
    sendBulkPaymentReminder,
    fetchOptions
};

const mapStateToProps = state => {
    return {
        properties: state.properties,
        options: state.options
    };
}


class SendBalanceReminders extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            properties: [],
            options: this.getOptions(),
            selectAllProperties: false,
            errors: {
                properties: ""
            },
            numErrors: 0
        }
        this.setFieldValues = this.setFieldValues.bind(this);
    }

    componentDidMount() {
        this.resetPropertyOptions();
        if(_.isEmpty(this.props.options)){
            this.props.fetchOptions();
        }
        // Mixpanel.track("Send bulk payment reminders modal: mounted");
    }

    getOptions(){
        let options = [];
        for (let property of Object.values(this.props.properties)){
            options.push({id: property.propertyId, label:property.propertyName});
        }
        return options;
    }

    resetPropertyOptions(){
        const options = this.getOptions();
        if(options.length > 0){
            this.setState({
                options,
                properties: options.length === 1 ? options : []
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.properties !== this.props.properties) {
          this.resetPropertyOptions();
        }
      }

    async validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let checks = [];

        switch(name){
            case "properties":
                checks = [check_empty_field];
            default:
                break;
        }

        await this.setState((prevState) => {
            let errors = {...prevState.errors};
            let numErrors = prevState.numErrors;
            for (let index in checks){
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0){
                    if (previousError.length == 0){
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                }else if(previousError.length > 0){
                    numErrors -= 1
                }
            }
            return {
               errors,
               numErrors
            };
        });
        return isValid;
    }

    getPropertyIds(properties){
        let ids = []
        if (properties.length > 0){
            for (let p of properties){
                ids.push(String(p.id))
            }
        }
        return ids
    }

    async onSubmit(){
        let fields = ["properties"];
        let results = [];
        for(let field of fields){
            let isValid = await this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter( (x) => !x);
        if(invalid_fields.length == 0){
            this.props.showLoading(true);
            console
            this.props.sendBulkPaymentReminder({propertyIds: this.getPropertyIds(this.state.properties)});
            if (this.props.notificationContext?.notification_type === 'payment_reminder') {
                Mixpanel.track("reminder: payment_reminder primary_action", {
                    notification_type: this.props.notificationContext.notification_type,
                    action: "send_reminders",
                    actionId: this.props.notificationContext.actionId || "unknown",
                    source: this.props.notificationContext.source || "unknown",
                    property_count: this.getPropertyIds(this.state.properties).length
                });
            }
            Mixpanel.track("Send Balance reminders btn");
            this.setFieldValues();
        }
    }

    setFieldValues(propertyIds=[]){
        this.setState({
            propertyIds
        })
    }

    handleSelectAll(event) {
        this.setState({
            properties: event.target.checked? this.state.options : [],
            selectAllProperties: event.target.checked
        })
    }


    render(){
        let options = [];
        for (let property of Object.values(this.props.properties)){
            options.push({id: property.propertyId, label:property.propertyName});
        }
        return (
        <React.Fragment>
            <Container>
                <Row className="mb-3">
                    <Col lg={12}>
                        <p>Use this form to send balance reminders to {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"} with account balances.</p>
                    </Col>

                </Row>

                <Row>
                    <Col sm={12}>
                        <FormGroup>
                            <Label className='h6' for="propertyId">
                                Select Properties:
                            </Label>

                            <Typeahead
                                options={this.state.options}
                                multiple
                                id="propertiesSendReminders"
                                labelKey="label"
                                placeholder='Select properties to send reminders to...'
                                selected={this.state.properties}
                                name="properties"
                                onChange={(selected) => this.setState({properties:selected})}
                                labelledBy={"Select"}
                            />
                            {this.state.errors.properties.length > 0 && <p className="text-danger">{this.state.errors.properties === "Field cannot be empty" ? "Please select a property" : this.state.errors.properties}</p>}
                        </FormGroup>

                        <Row className='mt-1 ml-1'>
                            <Input
                                className="mr-1"
                                type="checkbox"
                                id="selectAllProperties"
                                name="selectAllProperties"
                                value={this.state.selectAllProperties}
                                checked={this.state.selectAllProperties}
                                onChange={this.handleSelectAll.bind(this)}
                            /> Select All Properties
                        </Row>
                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col sm={12}>
                        <IonButton
                            id="sendRemindersBtnModal"
                            onClick={this.onSubmit.bind(this)}
                        >
                            Send Reminders
                        </IonButton>
                    </Col>

                </Row>

                <Row>
                    <Col sm={12}>
                        <hr color='lightgray' className='mt-2' />
                    </Col>
                    <p color="muted" className="p-2">
                        Note that reminders will be sent to all {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"} who have balances.
                        Please ensure you have adequate sms balance before sending the reminders
                    </p>


                </Row>



            </Container>

        </React.Fragment>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SendBalanceReminders);